import { func, number } from 'prop-types';
import React from 'react';
import { Col, Collapse, Row } from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';
import DateRange from '../../generic/DateRange';
import ExpandButton from '../../generic/ExpandButton/ExpandButton';
import { OpportunityLink } from '../../opportunities/Link';
import OpportunityForm from '../../opportunities/OpportunityForm';
import StageBadge from '../../opportunities/StageBadge';
import { opportunityShape } from '../../prop-types';

class AgreementRelatedOpportunity extends React.Component {
  state = { expanded: false };

  handleExpandToggle = () =>
    this.setState(state => ({ ...state, expanded: !state.expanded }));

  handleOpportunityChange = e => {
    const { opportunity, onChange } = this.props;

    onChange({
      target: {
        ...e.target,
        name: `${opportunity.id}.${e.target.name}`,
      },
    });
  };

  render() {
    const { opportunity, agreementBudget, agreementId } = this.props;
    const { id, expectedRevenue, campaignStart, campaignEnd, stage } =
      opportunity;
    const { expanded } = this.state;

    return (
      <>
        <div className="c-expandable sticky-top c-agreement__position-after-progress-bar-and-title mb-2">
          <div className="c-expandable__expander mr-4">
            <ExpandButton
              expanded={expanded}
              onClick={this.handleExpandToggle}
            />
          </div>
          <Row className="w-100">
            <Col sm={4} className="align-self-center text-truncate">
              <OpportunityLink
                model={opportunity}
                className="h4 mb-0 font-weight-semi-bold"
              />
            </Col>
            <Col sm={2}>
              <CurrencyFormat
                name="agreementBudget"
                value={agreementBudget}
                text
              />
              <div className="small text-muted">Agreement budget</div>
            </Col>
            <Col sm={2}>
              <CurrencyFormat
                name="expectedRevenue"
                value={expectedRevenue}
                text
              />
              <div className="small text-muted">Total opportunity budget</div>
            </Col>
            <Col
              sm={4}
              className="justify-content-between d-flex align-items-start"
            >
              <div>
                <DateRange
                  startName={`op-${id}.startDate.planned`}
                  endName={`op-${id}.endDate.planned`}
                  startDate={campaignStart}
                  endDate={campaignEnd}
                  small
                  readOnly
                  text
                />
                <div className="small text-muted">Timeframe</div>
              </div>
              <StageBadge stage={stage} />
            </Col>
          </Row>
        </div>
        <Collapse
          isOpen={expanded}
          className="mb-2 mt-n2 p-3 border-dark-gray rounded"
        >
          <OpportunityForm
            hideProgressBar
            model={opportunity}
            onChange={this.handleOpportunityChange}
            embeddedInAgreement
            currentAgreementId={agreementId}
          />
        </Collapse>
      </>
    );
  }
}

AgreementRelatedOpportunity.propTypes = {
  opportunity: opportunityShape.isRequired,
  agreementBudget: number.isRequired,
  onChange: func.isRequired,
  agreementId: number.isRequired,
};

export default AgreementRelatedOpportunity;
